<template>
  <div class='modal-container'>
    <div class='modal-header fl'>
      <h3>Vangnet</h3>
    </div>

    <div class='modal-body hf'>
      <h6 >Is er sprake van een vangnet?</h6>
      <p class='mb-3'>UWV vergoedt dan de loondoorbetaling.</p>
      <p>Bij de volgende situaties is er sprake van een vangnet:</p>
      <ul class='mb-4'>
        <li>Ziekte t.g.v. zwangerschap of klachten na de bevalling.</li>
        <li>Zieke t.g.v. orgaandonatie.</li>
        <li>No-riskpolis</li>
      </ul>
    </div>

    <div class='modal-footer'>
      <Button gray @click="this.handleClose" style="float: right;">{{ 'buttons.close' | translate}}</Button>
      <div style='clear: both;' />
    </div>
  </div>
</template>

<script>
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import Modal from '@/shared/constants/modal';

export default {
  name: 'InfoSafetyNetModal',
  components: {
    Button
  },
  props: {
    modalData: null
  },
  methods: {
    handleClose () {
      this.$store.dispatch(Modal.Actions.CLOSE);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
